import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../_service/shared.service';
import { Router } from '@angular/router';
import { LeadsService } from 'src/app/_service/leads.service';

@Component({
  selector: 'app-patient-journey-details',
  templateUrl: './patient-journey-details.component.html',
  styleUrls: ['./patient-journey-details.component.css']
})
export class PatientJourneyDetailsComponent implements OnInit {
  ipd_id: any = ''; patient_name = []; phone = []; cancel_ipd_remarks = []; dataLoaded: boolean = false;
  constructor(public leadapi: LeadsService, public router: Router, private sharedapi: SharedService, public dialogRef: MatDialogRef<PatientJourneyDetailsComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog) {

    if (data) {
      this.ipd_id = data;
      this.JourneyDetails(this.ipd_id);
    }
  }

  ngOnInit(): void {
  }

  async JourneyDetails(ipd_id) {
    this.dataLoaded = false;
    await this.leadapi.getIpdPatientJourneyDetails(this.ipd_id).subscribe((response: any) => {
      if (response.status) {
        this.dataLoaded = true;
        this.patient_name = response.data.patient;
        this.phone = response.data.phone;
        this.cancel_ipd_remarks = response.data.cancel_ipd_remarks;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  CloseModal(): void {
    this.dialogRef.close();
  }

}
